import { createApp } from 'vue';
import App from './App.vue';
import {createPinia} from "pinia";
import VueCookies from 'vue-cookies';
import i18n from "@/i18n";

const pinia = createPinia()
const app = createApp(App);

app.use(pinia)
app.use(VueCookies, { expire: '7d' }); // Setzt die Standard-Expire-Zeit für alle Cookies
app.use(i18n);
app.mount('#app');